<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="content"
        title="Content"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentProperties"
            :key="property.key"
            :is="property.component"
            :text="property.text"
            :property="property.property"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="style"
        title="Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in styleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="advanced"
        title="Advanced"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in advancedProperties"
            :key="property.key"
            :is="property.component"
            :element="element"
          ></component>
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ElementMenu from '../../contracts/ElementMenu'
  import ContentEventSelect from '../../MenuProperties/ContentEventSelect'
  export default ElementMenu.extend({
    components: {ContentEventSelect},
    data() {
      return {
        open: 'content',
      }
    },
    computed: {
      pageComponents() {
        return this.$store.getters['pageComponentModule/elements']()
      },
      popUps() {
        return this.pageComponents.filter(pageComponent => pageComponent.name == 'PopUp')
      },
      contentProperties() {
        let contentProperties = [...this.parent.properties.content]
        if (this.popUps.length) {
          contentProperties.push({key: 'events', component: 'ContentEventSelect'})
          contentProperties.push({key: 'event-data', component:'ContentText', text:'event data', property:'eventData'})
        }
        return contentProperties
      },
      styleProperties() {
        return this.parent.properties.styles
      },
      advancedProperties() {
        return this.parent.properties.advanced
      },
    }
  })
</script>
